import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Task } from 'src/app/core/models/task';
import { WebsocketService } from 'src/app/core/services/funder/websocket.service';
import { ToastService } from 'src/app/core/services/toast-service.service';

@Component({
  selector: 'app-task-info',
  templateUrl: './task-info.component.html',
  styleUrls: ['./task-info.component.scss']
})
export class TaskInfoComponent {
  @Input() public task!: Task;
  @Input() public routes: any;


  constructor(
    private router: Router,
    private websocketService: WebsocketService,
    private toastService: ToastService,
  ) {
  }

  goToRoute(){
    this.router.navigateByUrl(this.routes.administration.tasks.system_tasks);
  }
}
